/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavbarBrand, NavItem, NavLink } from 'reactstrap';
import { Login } from '../Login';
import { ErrorMessage } from '../System/ErrorMessage';
import { sysAdminSportOverviewPath, sysAdminSystemPropertyPath, sysAdminWebUsagePath } from '../SysAdminApp/sysAdminPathes';

export const MenuSysAdmin: React.FC<{}> = () => {
    return (
        <div className="wrap mw-100">
            <Navbar color="light">
                <NavbarBrand tag={Link} to={'/'}>
                    Funtip-SysAdmin
                </NavbarBrand>
                <Nav>
                    <NavItem>
                        <NavLink tag={Link} to={sysAdminWebUsagePath()}>
                            System
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={sysAdminSystemPropertyPath()}>
                            System-Properties
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={sysAdminSportOverviewPath()}>
                            Sports
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/user'}>
                            Users
                        </NavLink>
                    </NavItem>
                    <Login />
                    <ErrorMessage />
                </Nav>
            </Navbar>
        </div>
    );
};
